"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.percentage = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var percentage = function percentage(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'percentage-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M15.5303 4.46965C15.8232 4.76255 15.8232 5.23742 15.5303 5.53032L5.59099 15.4697C5.2981 15.7625 4.82322 15.7625 4.53033 15.4697C4.23744 15.1768 4.23744 14.7019 4.53033 14.409L14.4697 4.46965C14.7626 4.17676 15.2374 4.17676 15.5303 4.46965Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M6.5 5.74998C6.08579 5.74998 5.75 6.08577 5.75 6.49998C5.75 6.9142 6.08579 7.24998 6.5 7.24998C6.91421 7.24998 7.25 6.9142 7.25 6.49998C7.25 6.08577 6.91421 5.74998 6.5 5.74998ZM4.25 6.49998C4.25 5.25734 5.25736 4.24998 6.5 4.24998C7.74264 4.24998 8.75 5.25734 8.75 6.49998C8.75 7.74263 7.74264 8.74998 6.5 8.74998C5.25736 8.74998 4.25 7.74263 4.25 6.49998ZM13.5 12.75C13.0858 12.75 12.75 13.0858 12.75 13.5C12.75 13.9142 13.0858 14.25 13.5 14.25C13.9142 14.25 14.25 13.9142 14.25 13.5C14.25 13.0858 13.9142 12.75 13.5 12.75ZM11.25 13.5C11.25 12.2573 12.2574 11.25 13.5 11.25C14.7426 11.25 15.75 12.2573 15.75 13.5C15.75 14.7426 14.7426 15.75 13.5 15.75C12.2574 15.75 11.25 14.7426 11.25 13.5Z',
    fill: '#4B5563'
  }));
};

exports.percentage = percentage;